import { useContext, useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { FormStepContext } from '../components/stages/FormStepContext';
import { fetchReferenceData } from '../redux/slices/referencesSlice';

const useHandleGetTypesAndDomains = () => {
  const { currentStep, register, watch, setProjectType } =
    useContext(FormStepContext);
  const { data } = useSelector((s) => s.form);
  const { types, domains, loading, success, failed } = useSelector(
    (s) => s.references
  );
  const dispatch = useDispatch();
  const [typesList, setTypesList] = useState([]);
  const [currentNumber, setCurrentNumber] = useState(0);
  const watchedType = watch('type');

  useEffect(() => {
    if (
      !loading &&
      !success &&
      !failed &&
      (types.length < 1 || domains.length < 1)
    ) {
      dispatch(fetchReferenceData());
    }
  }, [types, domains, loading, success, failed]);

  useEffect(() => {
    if (types.length > 0 && typesList.length === 0) setTypesList(types);
  }, [types, typesList]);

  useEffect(() => {
    // set character's counter of description from landing page
    if (data.description) {
      const currentLength = data.description.length;
      setCurrentNumber(currentLength);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setProjectType(watchedType);
  }, [watchedType]);

  const countCharacters = (e) => {
    const currentLength = e.target.value.length;
    setCurrentNumber(currentLength);
  };

  return useMemo(
    () => ({
      data,
      loading,
      currentStep,
      typesList,
      watchedType,
      countCharacters,
      currentNumber,
      register,
    }),
    [data, loading, currentStep, watchedType, currentNumber, typesList]
  );
};

export default useHandleGetTypesAndDomains;
